import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Menu, Transition } from '@headlessui/react'
import { faCaretRight, faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAllSkillsForDropDown } from '../../redux/actions/skills';
import { Mixpanel } from '../../config/Mixpanel';
import { classNames } from '../../utils/classNames'
import Constants from '../../common/constants';
import { fetchIsUserFromBetaProduct } from '../../redux/actions/personaliseCourse';

const CoursesDropdownV2 = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [allCourses, setAllCourses] = useState([]);
    const [skills, setSkills] = useState(null);
    const [selectedCourse, setActiveCourse] = useState(null);
    const [selectedSkill, setActiveSkill] = useState(null);
    const all_courses = useSelector(store => store?.courses?.allCourses)
    const location = useLocation()
    const regex = /^.*\/.*\/.*\/.*\/\d+$/
    const email = useSelector(store => store?.profileDetails?.email)
    const [unlockedCourses, setUnlockedCourses] = useState([]);
    const user_role = useSelector((store) => store?.userSubscription?.user_role);
    const [isBeta, setIsBeta] = useState(false);
    const user_id = useSelector((store)=> store?.profileDetails?.id);

    useEffect(() => {
        // dispatch(
        //   getPersonaliseUnlockedCourses(
        //     email,
        //     (succesObj) => {
        //       setUnlockedCourses(succesObj);
        //     },
        //     (errorObj) => {}
        //   )
        // );
        if(user_id){
        dispatch(
          fetchIsUserFromBetaProduct((res) => {
            console.log("monday", res);
            if (res?.data?.is_ninjacurate_user || res?.data?.ninjacurate_is_paid) {
              setIsBeta(true);
            }
          })
        );
    }
      }, [user_id]);
      

    useEffect(() => {

        setAllCourses(all_courses);
        setActiveCourse(all_courses?.[0])

        const course_slug = all_courses?.[0]?.course_slug
        if (!regex.test(location.pathname) && (!skills || !skills?.[course_slug] )) {
            dispatch(getAllSkillsForDropDown(course_slug, (res) => {
                setSkills({
                    ...skills,
                    [course_slug]: res
                });
                setActiveSkill(res[0])
            }))
        };
    }, [])

    const handleSkillClick = (e) => {
        e.stopPropagation();
        Mixpanel.track(Constants.Mixpanel.DROPDOWN_SKILL_CLICK, {
            distinct_id: email
        })
    }

    const handleMSkillClick = (e) => {
        e.stopPropagation();
        // Mixpanel.track(Constants.Mixpanel.DROPDOWN_SKILL_CLICK, {
        //     distinct_id: email
        // })

        // to be changed for mskills
    }

    const handleCourseClick = (e) => {
        e.stopPropagation();
        Mixpanel.track(Constants.Mixpanel.DROPDOWN_COURSE_CLICK, {
            distinct_id: email
        })
    }

    return (
        <Menu as="div" className="relative inline-block text-left">
            <div>
                <Menu.Button className="px-3 py-1.5 border-2 border-gray-400 shadow-sm rounded font-semibold hover:shadow-lg">
                    All Categories
                </Menu.Button>
            </div>

            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className={`origin-top-left absolute left-0 mt-2 grid ${((isBeta)) ? 'grid-cols-2 w-[600px] ' : 'grid-cols-3 w-[864px] ' } rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden z-10`}>
                    <div className='bg-gray-100 py-2'>
                        <div className='text-center mt-1'>Categories</div>
                        <div className='overflow-y-auto mt-2 w-72 h-96'>
                            {allCourses?.map((course, idx) => (
                                <Menu.Item
                                    onMouseEnter={() => {
                                        if (skills?.[course?.course_slug]?.length === 0 || !skills || !skills?.[course?.course_slug]) {
                                            dispatch(getAllSkillsForDropDown(course?.course_slug, (res) => {
                                                setSkills({
                                                    ...skills,
                                                    [course.course_slug]: res
                                                });
                                                setActiveSkill(res[0])
                                            }))
                                        } else setActiveSkill(skills?.[course.course_slug]?.find(el => el.course_slug === course.course_slug))
                                        setActiveCourse(course)
                                    }}
                                    onClick={handleCourseClick}
                                    key={course.course_slug + idx}
                                >
                                    {({ active }) => (
                                        <span
                                            className={classNames(
                                                active ? 'bg-blue-100 text-blue-500' : '',
                                                `px-4 py-2 text-xs flex ${selectedCourse?.course_slug === course?.course_slug ? 'bg-blue-100 text-blue-500' : 'text-gray-700'}`
                                            )}
                                            onClick={(e) => navigate(`/${course.course_slug}`, { replace: true })}
                                        >
                                            <img src={course?.course_icon?.url} alt="Course Icon" className='w-4 h-4 mr-2' />
                                            {course["course-name"].replace("Course", "")}
                                            <FontAwesomeIcon className='self-center ml-1' icon={faCaretRight} />
                                        </span>
                                    )}
                                </Menu.Item>
                            ))}
                        </div>
                    </div>
                    <div className='py-2'>
                        <div className='text-center mt-1'>Skills</div>
                        <div className='overflow-y-auto mt-2 w-72 h-96'>
                            {skills?.[selectedCourse?.course_slug]?.length > 0 ?
                                <>
                                    {skills?.[selectedCourse?.course_slug]?.map((skill_item, idx) =>
                                        <Menu.Item
                                            key={skill_item?.skill_slug + idx}
                                            onMouseEnter={() => setActiveSkill(skill_item)}
                                            onClick={handleSkillClick}
                                        >
                                            {({ active }) => (
                                                <Link to={`/${selectedCourse.course_slug}/${skill_item?.["skill_slug"]}`}>
                                                    <div
                                                        className={classNames(
                                                            active ? 'bg-blue-100 text-blue-500' : 'text-gray-700',
                                                            `px-3 py-2 text-xs flex ${selectedSkill?.skill_slug === skill_item?.skill_slug ? 'bg-gray-100 text-blue-500' : 'text-gray-700'}`
                                                        )}

                                                    >
                                                        <img className="object-cover w-5 h-5 mr-1.5 self-center" src="https://img.icons8.com/external-flaticons-flat-flat-icons/64/000000/external-skills-resume-flaticons-flat-flat-icons-4.png" alt='skill-icon' />
                                                        <span className='self-center'>{skill_item?.["skill-name"]}</span>
                                                        <FontAwesomeIcon className='ml-1 self-center' icon={faCaretRight} />
                                                    </div>
                                                </Link>
                                            )}
                                        </Menu.Item>
                                    )}
                                </>
                                :
                                <div>
                                    <span className='inline-flex gap-2 animate-pulse p-2 text-xs'>
                                        Loading Skills...
                                        <FontAwesomeIcon className='mt-1' icon={faScrewdriverWrench} />
                                    </span>
                                </div>
                            }
                        </div>
                    </div>
                    {(!isBeta) && <div className='bg-gray-100 py-2'>
                        <div className='text-center mt-1'>Micro-Skills</div>
                        <div className='overflow-y-auto mt-2 w-72 h-96'>
                            {skills?.[selectedCourse?.course_slug]?.length > 0 ?
                                <>
                                    {selectedSkill?.all_mskills?.map((mskill_item, idx) =>
                                        <Menu.Item
                                            key={mskill_item?.mskill_slug + idx}
                                            onClick={handleMSkillClick}
                                        >
                                            {({ active }) => (
                                                <Link
                                                    to={`/${selectedCourse.course_slug}/${selectedSkill?.["skill_slug"]}/${mskill_item?.mskill_slug}/${mskill_item?.first_lesson ? mskill_item?.first_lesson[0]?.id : '..'}`}
                                                >
                                                    <div
                                                        className={classNames(
                                                            active ? 'bg-blue-100 text-blue-500' : 'text-gray-700',
                                                            'flex px-4 py-2 text-xs'
                                                        )}
                                                    >
                                                        <img className="object-cover w-4 h-4 mr-1.5 self-center" src="https://img.icons8.com/external-becris-flat-becris/64/000000/external-learning-artificial-intelligence-becris-flat-becris.png" alt='mskill-icon' />
                                                        <span className='self-center'>{mskill_item?.["mSkill-name"]}</span>
                                                    </div>
                                                </Link>
                                            )}
                                        </Menu.Item>
                                    )}
                                </>
                                :
                                <div>
                                    <span className='inline-flex gap-2 animate-pulse p-2 text-xs'>
                                        Loading MSkills...
                                        <FontAwesomeIcon className='mt-1' icon={faScrewdriverWrench} />
                                    </span>
                                </div>
                            }
                        </div>
                    </div>}
                </Menu.Items>
            </Transition>
        </Menu >
    )
}

export default CoursesDropdownV2